

const Input = ({ label, id, placeholder, type, value, setValue }) => {
    const handleChange = (event) => {
        setValue(event.target.value);
    };

    return (
        <div className="form-group mt-2">
            <label htmlFor={id}>{label}</label>
            <input
                type={type}
                className="form-control"
                id={id}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
            />
        </div>
    );
};

export default Input;
